import React from 'react';
import { GatsbyImage, ImageDataLike, getImage } from 'gatsby-plugin-image';

type QuizResultsCardProps = {
    imageData: ImageDataLike | undefined;
    alt: string | undefined;
};

export const QuizResultsCard = ({ imageData, alt }: QuizResultsCardProps) => {
    if (!imageData) {
        return <></>;
    }

    return <GatsbyImage image={getImage(imageData)} alt={alt ?? ``} />;
};
